import { useQuery } from '@tanstack/react-query'
import { chatService } from '../services/chatService'
import { useAppStore } from '../stores/appStore'
import { useAuthStore } from '../stores/authStore'

// Sohbet okunmamış sayısı — sidebar rozeti için (60 sn poll; SSE değişiminde invalidate edilir)
export function useChatUnread() {
  const activeCompany = useAppStore((s) => s.activeCompany)
  // PARTNER: iç sohbet uçları rol kapısıyla kapalı (403) — rozet sorulmaz;
  // partnerin sohbeti kendi sayfasında (`/partner/chat`) yaşar.
  const enabled = useAuthStore((s) => !!(s.user && s.token) && s.user?.role !== 'PARTNER' && !!s.user?.permissions
    && Object.keys(s.user.permissions).some((k) => k.startsWith('CHAT')))
  const co = activeCompany === '*' ? '01' : activeCompany

  const { data } = useQuery({
    queryKey: ['chat-unread', co],
    queryFn: () => chatService.unreadSummary(co),
    enabled,
    refetchInterval: 60000,
    staleTime: 30000,
    retry: false,
  })
  return {
    total: data?.data?.total || 0,
    perChannel: data?.data?.per_channel || {},
  }
}
